module.exports = function (fox) {
	'use strict';
	require('./templates/cancellation-offer.a.tpl')(fox);
	require('./widget/cancellation-offer-popup.es.js')(fox);
	require('./widget/action-popup.es.js')(fox);
	require('./stylus/_gui-elem.styl');
	require('./stylus/_discountCustom.styl');

};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/cancellation/index.js
// module id = 606
// module chunks = 4